import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    link: {
      textDecoration: "underline",
    },
  }),
  { name: "CancelButton" },
);
